module.exports = __webpack_public_path__ + "img/logo-full_demo.3847e4da.png";